// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImportXifinCoveragePopup-module__font-s-10___MfPN0 {
  font-size: 10px !important;
}

.ImportXifinCoveragePopup-module__font-s-12___mvnQo {
  font-size: 12px !important;
}

.ImportXifinCoveragePopup-module__font-s-13___M8LBk {
  font-size: 13px !important;
}

.ImportXifinCoveragePopup-module__font-s-14___LRCFX {
  font-size: 14px !important;
}

.ImportXifinCoveragePopup-module__font-s-15___nQDB4 {
  font-size: 15px !important;
}

.ImportXifinCoveragePopup-module__font-s-16___htYng {
  font-size: 16px !important;
}

.ImportXifinCoveragePopup-module__font-s-18___MCDEM {
  font-size: 18px !important;
}

.ImportXifinCoveragePopup-module__font-s-20___fjLvS {
  font-size: 20px !important;
}

.ImportXifinCoveragePopup-module__font-s-22___LD1db {
  font-size: 22px !important;
}

.ImportXifinCoveragePopup-module__font-s-28___yKmss {
  font-size: 28px !important;
}

.ImportXifinCoveragePopup-module__font-w-400___kVK1W {
  font-weight: 400 !important;
}

.ImportXifinCoveragePopup-module__font-w-500___R9BqE {
  font-weight: 500 !important;
}

.ImportXifinCoveragePopup-module__font-w-600___osswd {
  font-weight: 600 !important;
}

.ImportXifinCoveragePopup-module__font-w-700___DYdB8 {
  font-weight: 700 !important;
}

.ImportXifinCoveragePopup-module__p-5___LWdXq {
  padding: 5px !important;
}

.ImportXifinCoveragePopup-module__p-12___IH7V7 {
  padding: 12px !important;
}

.ImportXifinCoveragePopup-module__p-16___lvKLH {
  padding: 16px !important;
}

.ImportXifinCoveragePopup-module__p-30___mJUhr {
  padding: 30px !important;
}

.ImportXifinCoveragePopup-module__p-b-0___Py8IG {
  padding-bottom: 0 !important;
}

.ImportXifinCoveragePopup-module__p-b-5___jqIbn {
  padding-bottom: 5px !important;
}

.ImportXifinCoveragePopup-module__p-b-10___NVmof {
  padding-bottom: 10px !important;
}

.ImportXifinCoveragePopup-module__p-b-12___ZpxUv {
  padding-bottom: 12px !important;
}

.ImportXifinCoveragePopup-module__p-b-16___EDECq {
  padding-bottom: 16px !important;
}

.ImportXifinCoveragePopup-module__p-b-18___xjchx {
  padding-bottom: 18px !important;
}

.ImportXifinCoveragePopup-module__p-b-20___HF7L1 {
  padding-bottom: 20px !important;
}

.ImportXifinCoveragePopup-module__p-b-25___O0CH1 {
  padding-bottom: 25px !important;
}

.ImportXifinCoveragePopup-module__p-b-30___xs484 {
  padding-bottom: 30px !important;
}

.ImportXifinCoveragePopup-module__p-b-50___Z6WGc {
  padding-bottom: 50px !important;
}

.ImportXifinCoveragePopup-module__p-t-0___mNkto {
  padding-top: 0 !important;
}

.ImportXifinCoveragePopup-module__p-t-12___vBSrO {
  padding-top: 12px !important;
}

.ImportXifinCoveragePopup-module__p-t-16___wBiRe {
  padding-top: 16px !important;
}

.ImportXifinCoveragePopup-module__p-t-18___ONz1q {
  padding-top: 18px !important;
}

.ImportXifinCoveragePopup-module__p-t-20___EYxBW {
  padding-top: 20px !important;
}

.ImportXifinCoveragePopup-module__p-t-30___x8JOG {
  padding-top: 30px !important;
}

.ImportXifinCoveragePopup-module__p-t-40___N3xpt {
  padding-top: 40px !important;
}

.ImportXifinCoveragePopup-module__p-t-50___eqCaX {
  padding-top: 50px !important;
}

.ImportXifinCoveragePopup-module__p-l-20___sD9Jo {
  padding-left: 20px !important;
}

.ImportXifinCoveragePopup-module__p-l-30___ryEb8 {
  padding-left: 30px !important;
}

.ImportXifinCoveragePopup-module__p-l-40___O_DQU {
  padding-left: 40px !important;
}

.ImportXifinCoveragePopup-module__p-r-16___My7E7 {
  padding-right: 16px !important;
}

.ImportXifinCoveragePopup-module__p-r-20___ZqFSb {
  padding-right: 20px !important;
}

.ImportXifinCoveragePopup-module__p-r-30___lLrEM {
  padding-right: 30px !important;
}

.ImportXifinCoveragePopup-module__p-r-50___P9Y1s {
  padding-right: 50px !important;
}

.ImportXifinCoveragePopup-module__p-r-60___d5z9K {
  padding-right: 60px !important;
}

.ImportXifinCoveragePopup-module__m-b-1___ea7AP {
  margin-bottom: 1px !important;
}

.ImportXifinCoveragePopup-module__m-b-2___f1o41 {
  margin-bottom: 2px !important;
}

.ImportXifinCoveragePopup-module__m-b-6___V7jne {
  margin-bottom: 6px !important;
}

.ImportXifinCoveragePopup-module__m-b-8___eEVax {
  margin-bottom: 8px !important;
}

.ImportXifinCoveragePopup-module__m-b-10___SgWSH {
  margin-bottom: 10px !important;
}

.ImportXifinCoveragePopup-module__m-b-14___V8vAY {
  margin-bottom: 14px !important;
}

.ImportXifinCoveragePopup-module__m-b-16___Fcrly {
  margin-bottom: 16px !important;
}

.ImportXifinCoveragePopup-module__m-b-20___dsjO4 {
  margin-bottom: 20px !important;
}

.ImportXifinCoveragePopup-module__m-b-22___MdKMY {
  margin-bottom: 22px !important;
}

.ImportXifinCoveragePopup-module__m-b-24___nRygV {
  margin-bottom: 24px !important;
}

.ImportXifinCoveragePopup-module__m-b-30___eh52m {
  margin-bottom: 30px !important;
}

.ImportXifinCoveragePopup-module__m-b-32___gw815 {
  margin-bottom: 32px !important;
}

.ImportXifinCoveragePopup-module__m-b-40___jD_wc {
  margin-bottom: 40px !important;
}

.ImportXifinCoveragePopup-module__m-t-2___W2881 {
  margin-top: 2px !important;
}

.ImportXifinCoveragePopup-module__m-t-3___ZKLWn {
  margin-top: 3px !important;
}

.ImportXifinCoveragePopup-module__m-t-4___ev4wt {
  margin-top: 4px !important;
}

.ImportXifinCoveragePopup-module__m-t-5___bZTcf {
  margin-top: 5px !important;
}

.ImportXifinCoveragePopup-module__m-t-8___PlVrb {
  margin-top: 8px !important;
}

.ImportXifinCoveragePopup-module__m-t-10___ZM8iM {
  margin-top: 10px !important;
}

.ImportXifinCoveragePopup-module__m-t-15___ekdWT {
  margin-top: 15px !important;
}

.ImportXifinCoveragePopup-module__m-t-16___opLmf {
  margin-top: 16px !important;
}

.ImportXifinCoveragePopup-module__m-t-20___pll3M {
  margin-top: 20px !important;
}

.ImportXifinCoveragePopup-module__m-t-22___jvyYP {
  margin-top: 22px !important;
}

.ImportXifinCoveragePopup-module__m-t-30___fKnkt {
  margin-top: 30px !important;
}

.ImportXifinCoveragePopup-module__m-t-32___SrVeC {
  margin-top: 32px !important;
}

.ImportXifinCoveragePopup-module__m-l-auto___M72AS {
  margin-left: auto !important;
}

.ImportXifinCoveragePopup-module__m-l-4___VHa5j {
  margin-left: 4px !important;
}

.ImportXifinCoveragePopup-module__m-l-5___C6h7g {
  margin-left: 5px !important;
}

.ImportXifinCoveragePopup-module__m-l-6___UNJnv {
  margin-left: 6px !important;
}

.ImportXifinCoveragePopup-module__m-l-8___eFrhI {
  margin-left: 8px !important;
}

.ImportXifinCoveragePopup-module__m-l-10___DNiAj {
  margin-left: 10px !important;
}

.ImportXifinCoveragePopup-module__m-l-16___X7VaD {
  margin-left: 16px !important;
}

.ImportXifinCoveragePopup-module__m-l-20___vS_QD {
  margin-left: 20px !important;
}

.ImportXifinCoveragePopup-module__m-l-24___XwetL {
  margin-left: 24px !important;
}

.ImportXifinCoveragePopup-module__m-l-30___tGCaj {
  margin-left: 30px !important;
}

.ImportXifinCoveragePopup-module__m-l-35___bbnbt {
  margin-left: 35px !important;
}

.ImportXifinCoveragePopup-module__m-l-40___sl4I9 {
  margin-left: 40px !important;
}

.ImportXifinCoveragePopup-module__m-r-8___Hpoya {
  margin-right: 8px !important;
}

.ImportXifinCoveragePopup-module__m-r-10___Sb3JJ {
  margin-right: 10px !important;
}

.ImportXifinCoveragePopup-module__m-r-16___SNZvV {
  margin-right: 16px !important;
}

.ImportXifinCoveragePopup-module__m-r-20___Xf3zS {
  margin-right: 20px !important;
}

.ImportXifinCoveragePopup-module__m-r-24___VPcxO {
  margin-right: 24px !important;
}

.ImportXifinCoveragePopup-module__m-r-30___Wupll {
  margin-right: 30px !important;
}

.ImportXifinCoveragePopup-module__m-r-40___qoZO5 {
  margin-right: 40px !important;
}

.ImportXifinCoveragePopup-module__border-r-3___mbgz7 {
  border-radius: 3px !important;
}

.ImportXifinCoveragePopup-module__border-r-4___mqfcA {
  border-radius: 4px !important;
}

.ImportXifinCoveragePopup-module__border-r-6___ij6zL {
  border-radius: 6px !important;
}

.ImportXifinCoveragePopup-module__border-r-10___S944a {
  border-radius: 10px !important;
}

.ImportXifinCoveragePopup-module__border-r-12___HYfzv {
  border-radius: 12px !important;
}

.ImportXifinCoveragePopup-module__border-r-16___fpzpx {
  border-radius: 16px !important;
}

.ImportXifinCoveragePopup-module__border-r-50___Gk2ak {
  border-radius: 50% !important;
}

.ImportXifinCoveragePopup-module__primary-border___kA3Nn {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ImportXifinCoveragePopup-module__primary-border-b___glpRy {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ImportXifinCoveragePopup-module__primary-border-t___EhCIt {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ImportXifinCoveragePopup-module__primary-border-l___n9emI {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ImportXifinCoveragePopup-module__primary-border-r___Lj_5x {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ImportXifinCoveragePopup-module__secondary-border___e0R2d {
  border: 1px solid #637768;
}

.ImportXifinCoveragePopup-module__secondary-border-b___wjrXp {
  border-bottom: 1px solid #637768;
}

.ImportXifinCoveragePopup-module__secondary-border-t___vEEHK {
  border-top: 1px solid #637768;
}

.ImportXifinCoveragePopup-module__secondary-border-l___y8vVR {
  border-left: 1px solid #637768;
}

.ImportXifinCoveragePopup-module__secondary-border-r___ae3De {
  border-right: 1px solid #637768;
}

.ImportXifinCoveragePopup-module__gap-0___Oorty {
  gap: 0 !important;
}

.ImportXifinCoveragePopup-module__gap-2___YlP2d {
  gap: 2px !important;
}

.ImportXifinCoveragePopup-module__gap-4___EhrlX {
  gap: 4px !important;
}

.ImportXifinCoveragePopup-module__gap-5___JAGBZ {
  gap: 5px !important;
}

.ImportXifinCoveragePopup-module__gap-6___votP7 {
  gap: 6px !important;
}

.ImportXifinCoveragePopup-module__gap-8___kO8sX {
  gap: 8px !important;
}

.ImportXifinCoveragePopup-module__gap-10___yxhzR {
  gap: 10px !important;
}

.ImportXifinCoveragePopup-module__gap-12___L0SG5 {
  gap: 12px !important;
}

.ImportXifinCoveragePopup-module__gap-14___DPuFu {
  gap: 14px !important;
}

.ImportXifinCoveragePopup-module__gap-16___GLSW9 {
  gap: 16px !important;
}

.ImportXifinCoveragePopup-module__gap-18___bUGDc {
  gap: 18px !important;
}

.ImportXifinCoveragePopup-module__gap-20___QmNJ6 {
  gap: 20px !important;
}

.ImportXifinCoveragePopup-module__gap-24___NoXKO {
  gap: 24px !important;
}

.ImportXifinCoveragePopup-module__gap-26___cIy90 {
  gap: 26px !important;
}

.ImportXifinCoveragePopup-module__gap-30___WQbpq {
  gap: 30px !important;
}

.ImportXifinCoveragePopup-module__gap-32___Abuhr {
  gap: 32px !important;
}

.ImportXifinCoveragePopup-module__gap-40___Me2rn {
  gap: 40px !important;
}

.ImportXifinCoveragePopup-module__gap-50___cgCZf {
  gap: 50px !important;
}

.ImportXifinCoveragePopup-module__flex-1___f1yp5 {
  flex: 1;
}

.ImportXifinCoveragePopup-module__flex-none___ko3lR {
  flex: none !important;
}

.ImportXifinCoveragePopup-module__flex-column___eQryN {
  display: flex;
  flex-direction: column !important;
}

.ImportXifinCoveragePopup-module__flex-row___y_GZe {
  display: flex;
  flex-direction: row !important;
}

.ImportXifinCoveragePopup-module__vertically-centered___nsyua {
  display: flex;
  align-items: center !important;
}

.ImportXifinCoveragePopup-module__horizontally-centered___P6ClH {
  display: flex;
  justify-content: center !important;
}

.ImportXifinCoveragePopup-module__horizontally-end___BJlYs {
  display: flex;
  justify-content: end !important;
}

.ImportXifinCoveragePopup-module__vertically-start___xuHMU {
  display: flex;
  align-items: start !important;
}

.ImportXifinCoveragePopup-module__space-between___e3DgA {
  display: flex;
  justify-content: space-between !important;
}

.ImportXifinCoveragePopup-module__flex-wrap___ut5Vu {
  flex-wrap: wrap !important;
}

.ImportXifinCoveragePopup-module__height-100___vrGqA {
  height: 100%;
}

.ImportXifinCoveragePopup-module__width-50___XAsuQ {
  width: 50% !important;
}

.ImportXifinCoveragePopup-module__width-100___FZfw8 {
  width: 100%;
}

.ImportXifinCoveragePopup-module__cursor-pointer___Urlrt {
  cursor: pointer;
}

.ImportXifinCoveragePopup-module__cursor-not-allowed___T004j {
  cursor: not-allowed !important;
}

.ImportXifinCoveragePopup-module__absolute-centered___ktM3M {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ImportXifinCoveragePopup-module__absolute___BRoxq {
  position: absolute;
}

.ImportXifinCoveragePopup-module__relative___FJXTy {
  position: relative;
}

.ImportXifinCoveragePopup-module__fixed___ZdlCd {
  position: fixed;
}

.ImportXifinCoveragePopup-module__visible___HaJh1 {
  opacity: 1;
}

.ImportXifinCoveragePopup-module__invisible___kwrky {
  opacity: 0;
}

.ImportXifinCoveragePopup-module__col-90___TspzP {
  width: 90% !important;
}

.ImportXifinCoveragePopup-module__col-auto___mCH0x {
  width: auto !important;
}

.ImportXifinCoveragePopup-module__medical-tabs___eIog4 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ImportXifinCoveragePopup-module__medical-table-new___zdzDF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF::-webkit-scrollbar-track {
  display: none;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF.ImportXifinCoveragePopup-module__no-pagination___lqraI {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF.ImportXifinCoveragePopup-module__no-pagination___lqraI:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF.ImportXifinCoveragePopup-module__no-pagination___lqraI::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ImportXifinCoveragePopup-module__medical-table-new___zdzDF.ImportXifinCoveragePopup-module__no-pagination___lqraI::-webkit-scrollbar-track {
  display: none;
}

.ImportXifinCoveragePopup-module__medical-table-empty___qvRJQ {
  padding: 14px 40px !important;
}

.ImportXifinCoveragePopup-module__icon-btn___SG6yU {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ImportXifinCoveragePopup-module__search-icon___VjFwz {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ImportXifinCoveragePopup-module__disable-select___treRR {
  user-select: none;
}

.ImportXifinCoveragePopup-module__break-word___eSIZG {
  word-break: break-word;
}

.ImportXifinCoveragePopup-module__popup-clear-btn___PI6iE {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ImportXifinCoveragePopup-module__scroll-m-b-20___DDxDx {
  scroll-margin-bottom: 20px;
}

.ImportXifinCoveragePopup-module__body___EBI00 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 560px;
  padding: 20px 30px 5px;
}

.ImportXifinCoveragePopup-module__instructions___f6Wnn {
  color: #859989;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
}

.ImportXifinCoveragePopup-module__fileLabel___MKikE {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  margin-top: 4px;
}
.ImportXifinCoveragePopup-module__fileLabel___MKikE input[type=text] {
  border: 1px solid #a8eccc;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  padding: 8px 10px;
}

.ImportXifinCoveragePopup-module__progress___FyAvR {
  align-items: center;
  display: flex;
  gap: 12px;
}

.ImportXifinCoveragePopup-module__progressBar___oylJf {
  background: rgba(55, 88, 68, 0.5019607843);
  border-radius: 999px;
  flex: 1;
  height: 8px;
  overflow: hidden;
}
.ImportXifinCoveragePopup-module__progressBar___oylJf span {
  background: #859989;
  display: block;
  height: 100%;
  transition: width 0.4s ease;
}

.ImportXifinCoveragePopup-module__progressText___eQNOg {
  color: #859989;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.ImportXifinCoveragePopup-module__tableScroll___EAWj_ {
  border: 1px solid #a8eccc;
  border-radius: 6px;
  max-height: 280px;
  overflow: auto;
}

.ImportXifinCoveragePopup-module__resultsTable___t_jTG {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}
.ImportXifinCoveragePopup-module__resultsTable___t_jTG th {
  background: rgba(55, 88, 68, 0.5019607843);
  color: #859989;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 8px 12px;
  position: sticky;
  text-align: left;
  text-transform: uppercase;
  top: 0;
}
.ImportXifinCoveragePopup-module__resultsTable___t_jTG td {
  border-top: 1px solid rgba(55, 88, 68, 0.5019607843);
  color: #375844;
  padding: 8px 12px;
  vertical-align: top;
}
.ImportXifinCoveragePopup-module__resultsTable___t_jTG .ImportXifinCoveragePopup-module__detailCell___bQHpV {
  color: #859989;
  word-break: break-word;
}

.ImportXifinCoveragePopup-module__chip___hG9Cu {
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  text-transform: capitalize;
  white-space: nowrap;
}

.ImportXifinCoveragePopup-module__outcomeChange___uZdWU {
  background: #e7f0fb;
  color: #1f5fa8;
}

.ImportXifinCoveragePopup-module__outcomeReview___JrGI3 {
  background: #fdf0e1;
  color: #a8621f;
}

.ImportXifinCoveragePopup-module__outcomeOk___UUOF_ {
  background: #e7f4ec;
  color: #375844;
}

.ImportXifinCoveragePopup-module__error___f92mC {
  background: #fcebea;
  border-radius: 6px;
  color: #a82c27;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  padding: 12px 14px;
}

.ImportXifinCoveragePopup-module__warning___ChK_O {
  color: #a8621f;
  font-size: 13px;
  line-height: 1.4;
  margin: 4px 0 0;
}

.ImportXifinCoveragePopup-module__summary___tPbMo {
  background: rgba(55, 88, 68, 0.5019607843);
  border: 1px solid #a8eccc;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
}

.ImportXifinCoveragePopup-module__summaryTitle___BKUQp {
  color: #375844;
  font-size: 14px;
  font-weight: 600;
}

.ImportXifinCoveragePopup-module__summaryGrid___cX2zj {
  display: grid;
  gap: 6px 24px;
  grid-template-columns: 1fr 1fr;
  margin: 0;
}
.ImportXifinCoveragePopup-module__summaryGrid___cX2zj .ImportXifinCoveragePopup-module__summaryItem___JDQiU {
  align-items: baseline;
  display: flex;
  gap: 8px;
  justify-content: space-between;
}
.ImportXifinCoveragePopup-module__summaryGrid___cX2zj .ImportXifinCoveragePopup-module__summaryItem___JDQiU dt {
  color: #859989;
  font-size: 13px;
  font-weight: 500;
}
.ImportXifinCoveragePopup-module__summaryGrid___cX2zj .ImportXifinCoveragePopup-module__summaryItem___JDQiU dd {
  color: #375844;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
}

.ImportXifinCoveragePopup-module__resumeButton___Fj9vu {
  align-self: flex-start;
  background: none;
  border: none;
  color: #859989;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  padding: 0;
  text-decoration: underline;
}

.ImportXifinCoveragePopup-module__footer___KB6ri {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 20px 30px;
}

@media (max-width: 640px) {
  .ImportXifinCoveragePopup-module__summaryGrid___cX2zj {
    grid-template-columns: 1fr;
  }
  .ImportXifinCoveragePopup-module__footer___KB6ri {
    flex-direction: column;
  }
  .ImportXifinCoveragePopup-module__footer___KB6ri button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/ImportXifinCoveragePopup/ImportXifinCoveragePopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA8pBJ;;AA1pBA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AA6pBF;;AA1pBA;EACE,0CAAA;EACA,oBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;AA6pBF;AA3pBE;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,2BAAA;AA6pBJ;;AAzpBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA4pBF;;AAzpBA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,yBAAA;EACA,eAAA;EACA,WAAA;AA4pBF;AA1pBE;EACE,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,MAAA;AA4pBJ;AAzpBE;EACE,oDAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AA2pBJ;AAxpBE;EACE,cAAA;EACA,sBAAA;AA0pBJ;;AAtpBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAypBF;;AAtpBA;EACE,mBAAA;EACA,cAAA;AAypBF;;AAtpBA;EACE,mBAAA;EACA,cAAA;AAypBF;;AAtpBA;EACE,mBAAA;EACA,cAAA;AAypBF;;AAtpBA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AAypBF;;AAtpBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAypBF;;AAtpBA;EACE,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAypBF;;AAtpBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAypBF;;AAtpBA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAypBF;AAvpBE;EACE,qBAAA;EACA,aAAA;EACA,QAAA;EACA,8BAAA;AAypBJ;AAvpBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAypBN;AAtpBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAwpBN;;AAnpBA;EACE,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,0BAAA;AAspBF;;AAnpBA;EACE,2CAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAspBF;;AAnpBA;EACE;IACE,0BAAA;EAspBF;EAnpBA;IACE,sBAAA;EAqpBF;EAnpBE;IACE,WAAA;EAqpBJ;AACF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 560px;\n  padding: 20px 30px 5px;\n}\n\n.instructions {\n  color: get-color(greenNew, medium);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.fileLabel {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 600;\n  gap: 8px;\n  margin-top: 4px;\n\n  input[type='text'] {\n    border: 1px solid get-color(greenNew, light);\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 400;\n    padding: 8px 10px;\n  }\n}\n\n.progress {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.progressBar {\n  background: get-color(greenNew, lightest);\n  border-radius: 999px;\n  flex: 1;\n  height: 8px;\n  overflow: hidden;\n\n  span {\n    background: get-color(greenNew, medium);\n    display: block;\n    height: 100%;\n    transition: width 0.4s ease;\n  }\n}\n\n.progressText {\n  color: get-color(greenNew, medium);\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.tableScroll {\n  border: 1px solid get-color(greenNew, light);\n  border-radius: 6px;\n  max-height: 280px;\n  overflow: auto;\n}\n\n.resultsTable {\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n\n  th {\n    background: get-color(greenNew, lightest);\n    color: get-color(greenNew, medium);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    padding: 8px 12px;\n    position: sticky;\n    text-align: left;\n    text-transform: uppercase;\n    top: 0;\n  }\n\n  td {\n    border-top: 1px solid get-color(greenNew, lightest);\n    color: get-color(greenNew, dark);\n    padding: 8px 12px;\n    vertical-align: top;\n  }\n\n  .detailCell {\n    color: get-color(greenNew, medium);\n    word-break: break-word;\n  }\n}\n\n.chip {\n  border-radius: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n\n.outcomeChange {\n  background: #e7f0fb;\n  color: #1f5fa8;\n}\n\n.outcomeReview {\n  background: #fdf0e1;\n  color: #a8621f;\n}\n\n.outcomeOk {\n  background: #e7f4ec;\n  color: get-color(greenNew, dark);\n}\n\n.error {\n  background: #fcebea;\n  border-radius: 6px;\n  color: #a82c27;\n  font-size: 14px;\n  line-height: 1.4;\n  margin: 0;\n  padding: 12px 14px;\n}\n\n.warning {\n  color: #a8621f;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 4px 0 0;\n}\n\n.summary {\n  background: get-color(greenNew, lightest);\n  border: 1px solid get-color(greenNew, light);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n}\n\n.summaryTitle {\n  color: get-color(greenNew, dark);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.summaryGrid {\n  display: grid;\n  gap: 6px 24px;\n  grid-template-columns: 1fr 1fr;\n  margin: 0;\n\n  .summaryItem {\n    align-items: baseline;\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n\n    dt {\n      color: get-color(greenNew, medium);\n      font-size: 13px;\n      font-weight: 500;\n    }\n\n    dd {\n      color: get-color(greenNew, dark);\n      font-size: 14px;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n}\n\n.resumeButton {\n  align-self: flex-start;\n  background: none;\n  border: none;\n  color: get-color(greenNew, medium);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.footer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 20px 30px;\n}\n\n@media (max-width: 640px) {\n  .summaryGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .footer {\n    flex-direction: column;\n\n    button {\n      width: 100%;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ImportXifinCoveragePopup-module__font-s-10___MfPN0`,
	"fontS12": `ImportXifinCoveragePopup-module__font-s-12___mvnQo`,
	"fontS13": `ImportXifinCoveragePopup-module__font-s-13___M8LBk`,
	"fontS14": `ImportXifinCoveragePopup-module__font-s-14___LRCFX`,
	"fontS15": `ImportXifinCoveragePopup-module__font-s-15___nQDB4`,
	"fontS16": `ImportXifinCoveragePopup-module__font-s-16___htYng`,
	"fontS18": `ImportXifinCoveragePopup-module__font-s-18___MCDEM`,
	"fontS20": `ImportXifinCoveragePopup-module__font-s-20___fjLvS`,
	"fontS22": `ImportXifinCoveragePopup-module__font-s-22___LD1db`,
	"fontS28": `ImportXifinCoveragePopup-module__font-s-28___yKmss`,
	"fontW400": `ImportXifinCoveragePopup-module__font-w-400___kVK1W`,
	"fontW500": `ImportXifinCoveragePopup-module__font-w-500___R9BqE`,
	"fontW600": `ImportXifinCoveragePopup-module__font-w-600___osswd`,
	"fontW700": `ImportXifinCoveragePopup-module__font-w-700___DYdB8`,
	"p5": `ImportXifinCoveragePopup-module__p-5___LWdXq`,
	"p12": `ImportXifinCoveragePopup-module__p-12___IH7V7`,
	"p16": `ImportXifinCoveragePopup-module__p-16___lvKLH`,
	"p30": `ImportXifinCoveragePopup-module__p-30___mJUhr`,
	"pB0": `ImportXifinCoveragePopup-module__p-b-0___Py8IG`,
	"pB5": `ImportXifinCoveragePopup-module__p-b-5___jqIbn`,
	"pB10": `ImportXifinCoveragePopup-module__p-b-10___NVmof`,
	"pB12": `ImportXifinCoveragePopup-module__p-b-12___ZpxUv`,
	"pB16": `ImportXifinCoveragePopup-module__p-b-16___EDECq`,
	"pB18": `ImportXifinCoveragePopup-module__p-b-18___xjchx`,
	"pB20": `ImportXifinCoveragePopup-module__p-b-20___HF7L1`,
	"pB25": `ImportXifinCoveragePopup-module__p-b-25___O0CH1`,
	"pB30": `ImportXifinCoveragePopup-module__p-b-30___xs484`,
	"pB50": `ImportXifinCoveragePopup-module__p-b-50___Z6WGc`,
	"pT0": `ImportXifinCoveragePopup-module__p-t-0___mNkto`,
	"pT12": `ImportXifinCoveragePopup-module__p-t-12___vBSrO`,
	"pT16": `ImportXifinCoveragePopup-module__p-t-16___wBiRe`,
	"pT18": `ImportXifinCoveragePopup-module__p-t-18___ONz1q`,
	"pT20": `ImportXifinCoveragePopup-module__p-t-20___EYxBW`,
	"pT30": `ImportXifinCoveragePopup-module__p-t-30___x8JOG`,
	"pT40": `ImportXifinCoveragePopup-module__p-t-40___N3xpt`,
	"pT50": `ImportXifinCoveragePopup-module__p-t-50___eqCaX`,
	"pL20": `ImportXifinCoveragePopup-module__p-l-20___sD9Jo`,
	"pL30": `ImportXifinCoveragePopup-module__p-l-30___ryEb8`,
	"pL40": `ImportXifinCoveragePopup-module__p-l-40___O_DQU`,
	"pR16": `ImportXifinCoveragePopup-module__p-r-16___My7E7`,
	"pR20": `ImportXifinCoveragePopup-module__p-r-20___ZqFSb`,
	"pR30": `ImportXifinCoveragePopup-module__p-r-30___lLrEM`,
	"pR50": `ImportXifinCoveragePopup-module__p-r-50___P9Y1s`,
	"pR60": `ImportXifinCoveragePopup-module__p-r-60___d5z9K`,
	"mB1": `ImportXifinCoveragePopup-module__m-b-1___ea7AP`,
	"mB2": `ImportXifinCoveragePopup-module__m-b-2___f1o41`,
	"mB6": `ImportXifinCoveragePopup-module__m-b-6___V7jne`,
	"mB8": `ImportXifinCoveragePopup-module__m-b-8___eEVax`,
	"mB10": `ImportXifinCoveragePopup-module__m-b-10___SgWSH`,
	"mB14": `ImportXifinCoveragePopup-module__m-b-14___V8vAY`,
	"mB16": `ImportXifinCoveragePopup-module__m-b-16___Fcrly`,
	"mB20": `ImportXifinCoveragePopup-module__m-b-20___dsjO4`,
	"mB22": `ImportXifinCoveragePopup-module__m-b-22___MdKMY`,
	"mB24": `ImportXifinCoveragePopup-module__m-b-24___nRygV`,
	"mB30": `ImportXifinCoveragePopup-module__m-b-30___eh52m`,
	"mB32": `ImportXifinCoveragePopup-module__m-b-32___gw815`,
	"mB40": `ImportXifinCoveragePopup-module__m-b-40___jD_wc`,
	"mT2": `ImportXifinCoveragePopup-module__m-t-2___W2881`,
	"mT3": `ImportXifinCoveragePopup-module__m-t-3___ZKLWn`,
	"mT4": `ImportXifinCoveragePopup-module__m-t-4___ev4wt`,
	"mT5": `ImportXifinCoveragePopup-module__m-t-5___bZTcf`,
	"mT8": `ImportXifinCoveragePopup-module__m-t-8___PlVrb`,
	"mT10": `ImportXifinCoveragePopup-module__m-t-10___ZM8iM`,
	"mT15": `ImportXifinCoveragePopup-module__m-t-15___ekdWT`,
	"mT16": `ImportXifinCoveragePopup-module__m-t-16___opLmf`,
	"mT20": `ImportXifinCoveragePopup-module__m-t-20___pll3M`,
	"mT22": `ImportXifinCoveragePopup-module__m-t-22___jvyYP`,
	"mT30": `ImportXifinCoveragePopup-module__m-t-30___fKnkt`,
	"mT32": `ImportXifinCoveragePopup-module__m-t-32___SrVeC`,
	"mLAuto": `ImportXifinCoveragePopup-module__m-l-auto___M72AS`,
	"mL4": `ImportXifinCoveragePopup-module__m-l-4___VHa5j`,
	"mL5": `ImportXifinCoveragePopup-module__m-l-5___C6h7g`,
	"mL6": `ImportXifinCoveragePopup-module__m-l-6___UNJnv`,
	"mL8": `ImportXifinCoveragePopup-module__m-l-8___eFrhI`,
	"mL10": `ImportXifinCoveragePopup-module__m-l-10___DNiAj`,
	"mL16": `ImportXifinCoveragePopup-module__m-l-16___X7VaD`,
	"mL20": `ImportXifinCoveragePopup-module__m-l-20___vS_QD`,
	"mL24": `ImportXifinCoveragePopup-module__m-l-24___XwetL`,
	"mL30": `ImportXifinCoveragePopup-module__m-l-30___tGCaj`,
	"mL35": `ImportXifinCoveragePopup-module__m-l-35___bbnbt`,
	"mL40": `ImportXifinCoveragePopup-module__m-l-40___sl4I9`,
	"mR8": `ImportXifinCoveragePopup-module__m-r-8___Hpoya`,
	"mR10": `ImportXifinCoveragePopup-module__m-r-10___Sb3JJ`,
	"mR16": `ImportXifinCoveragePopup-module__m-r-16___SNZvV`,
	"mR20": `ImportXifinCoveragePopup-module__m-r-20___Xf3zS`,
	"mR24": `ImportXifinCoveragePopup-module__m-r-24___VPcxO`,
	"mR30": `ImportXifinCoveragePopup-module__m-r-30___Wupll`,
	"mR40": `ImportXifinCoveragePopup-module__m-r-40___qoZO5`,
	"borderR3": `ImportXifinCoveragePopup-module__border-r-3___mbgz7`,
	"borderR4": `ImportXifinCoveragePopup-module__border-r-4___mqfcA`,
	"borderR6": `ImportXifinCoveragePopup-module__border-r-6___ij6zL`,
	"borderR10": `ImportXifinCoveragePopup-module__border-r-10___S944a`,
	"borderR12": `ImportXifinCoveragePopup-module__border-r-12___HYfzv`,
	"borderR16": `ImportXifinCoveragePopup-module__border-r-16___fpzpx`,
	"borderR50": `ImportXifinCoveragePopup-module__border-r-50___Gk2ak`,
	"primaryBorder": `ImportXifinCoveragePopup-module__primary-border___kA3Nn`,
	"primaryBorderB": `ImportXifinCoveragePopup-module__primary-border-b___glpRy`,
	"primaryBorderT": `ImportXifinCoveragePopup-module__primary-border-t___EhCIt`,
	"primaryBorderL": `ImportXifinCoveragePopup-module__primary-border-l___n9emI`,
	"primaryBorderR": `ImportXifinCoveragePopup-module__primary-border-r___Lj_5x`,
	"secondaryBorder": `ImportXifinCoveragePopup-module__secondary-border___e0R2d`,
	"secondaryBorderB": `ImportXifinCoveragePopup-module__secondary-border-b___wjrXp`,
	"secondaryBorderT": `ImportXifinCoveragePopup-module__secondary-border-t___vEEHK`,
	"secondaryBorderL": `ImportXifinCoveragePopup-module__secondary-border-l___y8vVR`,
	"secondaryBorderR": `ImportXifinCoveragePopup-module__secondary-border-r___ae3De`,
	"gap0": `ImportXifinCoveragePopup-module__gap-0___Oorty`,
	"gap2": `ImportXifinCoveragePopup-module__gap-2___YlP2d`,
	"gap4": `ImportXifinCoveragePopup-module__gap-4___EhrlX`,
	"gap5": `ImportXifinCoveragePopup-module__gap-5___JAGBZ`,
	"gap6": `ImportXifinCoveragePopup-module__gap-6___votP7`,
	"gap8": `ImportXifinCoveragePopup-module__gap-8___kO8sX`,
	"gap10": `ImportXifinCoveragePopup-module__gap-10___yxhzR`,
	"gap12": `ImportXifinCoveragePopup-module__gap-12___L0SG5`,
	"gap14": `ImportXifinCoveragePopup-module__gap-14___DPuFu`,
	"gap16": `ImportXifinCoveragePopup-module__gap-16___GLSW9`,
	"gap18": `ImportXifinCoveragePopup-module__gap-18___bUGDc`,
	"gap20": `ImportXifinCoveragePopup-module__gap-20___QmNJ6`,
	"gap24": `ImportXifinCoveragePopup-module__gap-24___NoXKO`,
	"gap26": `ImportXifinCoveragePopup-module__gap-26___cIy90`,
	"gap30": `ImportXifinCoveragePopup-module__gap-30___WQbpq`,
	"gap32": `ImportXifinCoveragePopup-module__gap-32___Abuhr`,
	"gap40": `ImportXifinCoveragePopup-module__gap-40___Me2rn`,
	"gap50": `ImportXifinCoveragePopup-module__gap-50___cgCZf`,
	"flex1": `ImportXifinCoveragePopup-module__flex-1___f1yp5`,
	"flexNone": `ImportXifinCoveragePopup-module__flex-none___ko3lR`,
	"flexColumn": `ImportXifinCoveragePopup-module__flex-column___eQryN`,
	"flexRow": `ImportXifinCoveragePopup-module__flex-row___y_GZe`,
	"verticallyCentered": `ImportXifinCoveragePopup-module__vertically-centered___nsyua`,
	"horizontallyCentered": `ImportXifinCoveragePopup-module__horizontally-centered___P6ClH`,
	"horizontallyEnd": `ImportXifinCoveragePopup-module__horizontally-end___BJlYs`,
	"verticallyStart": `ImportXifinCoveragePopup-module__vertically-start___xuHMU`,
	"spaceBetween": `ImportXifinCoveragePopup-module__space-between___e3DgA`,
	"flexWrap": `ImportXifinCoveragePopup-module__flex-wrap___ut5Vu`,
	"height100": `ImportXifinCoveragePopup-module__height-100___vrGqA`,
	"width50": `ImportXifinCoveragePopup-module__width-50___XAsuQ`,
	"width100": `ImportXifinCoveragePopup-module__width-100___FZfw8`,
	"cursorPointer": `ImportXifinCoveragePopup-module__cursor-pointer___Urlrt`,
	"cursorNotAllowed": `ImportXifinCoveragePopup-module__cursor-not-allowed___T004j`,
	"absoluteCentered": `ImportXifinCoveragePopup-module__absolute-centered___ktM3M`,
	"absolute": `ImportXifinCoveragePopup-module__absolute___BRoxq`,
	"relative": `ImportXifinCoveragePopup-module__relative___FJXTy`,
	"fixed": `ImportXifinCoveragePopup-module__fixed___ZdlCd`,
	"visible": `ImportXifinCoveragePopup-module__visible___HaJh1`,
	"invisible": `ImportXifinCoveragePopup-module__invisible___kwrky`,
	"col90": `ImportXifinCoveragePopup-module__col-90___TspzP`,
	"colAuto": `ImportXifinCoveragePopup-module__col-auto___mCH0x`,
	"medicalTabs": `ImportXifinCoveragePopup-module__medical-tabs___eIog4`,
	"medicalTableNew": `ImportXifinCoveragePopup-module__medical-table-new___zdzDF`,
	"noPagination": `ImportXifinCoveragePopup-module__no-pagination___lqraI`,
	"medicalTableEmpty": `ImportXifinCoveragePopup-module__medical-table-empty___qvRJQ`,
	"iconBtn": `ImportXifinCoveragePopup-module__icon-btn___SG6yU`,
	"searchIcon": `ImportXifinCoveragePopup-module__search-icon___VjFwz`,
	"disableSelect": `ImportXifinCoveragePopup-module__disable-select___treRR`,
	"breakWord": `ImportXifinCoveragePopup-module__break-word___eSIZG`,
	"popupClearBtn": `ImportXifinCoveragePopup-module__popup-clear-btn___PI6iE`,
	"scrollMB20": `ImportXifinCoveragePopup-module__scroll-m-b-20___DDxDx`,
	"body": `ImportXifinCoveragePopup-module__body___EBI00`,
	"instructions": `ImportXifinCoveragePopup-module__instructions___f6Wnn`,
	"fileLabel": `ImportXifinCoveragePopup-module__fileLabel___MKikE`,
	"progress": `ImportXifinCoveragePopup-module__progress___FyAvR`,
	"progressBar": `ImportXifinCoveragePopup-module__progressBar___oylJf`,
	"progressText": `ImportXifinCoveragePopup-module__progressText___eQNOg`,
	"tableScroll": `ImportXifinCoveragePopup-module__tableScroll___EAWj_`,
	"resultsTable": `ImportXifinCoveragePopup-module__resultsTable___t_jTG`,
	"detailCell": `ImportXifinCoveragePopup-module__detailCell___bQHpV`,
	"chip": `ImportXifinCoveragePopup-module__chip___hG9Cu`,
	"outcomeChange": `ImportXifinCoveragePopup-module__outcomeChange___uZdWU`,
	"outcomeReview": `ImportXifinCoveragePopup-module__outcomeReview___JrGI3`,
	"outcomeOk": `ImportXifinCoveragePopup-module__outcomeOk___UUOF_`,
	"error": `ImportXifinCoveragePopup-module__error___f92mC`,
	"warning": `ImportXifinCoveragePopup-module__warning___ChK_O`,
	"summary": `ImportXifinCoveragePopup-module__summary___tPbMo`,
	"summaryTitle": `ImportXifinCoveragePopup-module__summaryTitle___BKUQp`,
	"summaryGrid": `ImportXifinCoveragePopup-module__summaryGrid___cX2zj`,
	"summaryItem": `ImportXifinCoveragePopup-module__summaryItem___JDQiU`,
	"resumeButton": `ImportXifinCoveragePopup-module__resumeButton___Fj9vu`,
	"footer": `ImportXifinCoveragePopup-module__footer___KB6ri`
};
module.exports = ___CSS_LOADER_EXPORT___;
